/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

export const saveAndUpdateRiderDetails = async (body: Record<string, any>) => {
  try {
    const response: any = await axiosInstance.post(API_URLS.saveUpdateRider, body);
    return response;
  } catch (response: any) {
    throw new Error(response?.message);
  }
};

export const deleteRiderDetails = async (id: string) => {
  try {
    await axiosInstance.post(API_URLS.deleteRider, { id });
  } catch (response: any) {
    throw new Error(response?.message);
  }
};
